import { Container, Grid } from "@material-ui/core";
import Menu from "../../Components/Menu";
import styled from "@emotion/styled";
import Background from "../../img/S1_background.png";

const S4_Homepage = () => {
  const MainDiv = styled.div``;
  const MainDiv2 = styled.div`
    max-width: 1000px;
    background-color: #b82e3c;
    padding: 30px;
  `;
  const MainDiv3 = styled.div`
    max-width: 1000px;
    color: #ffffff;
    border-top: 2px solid #ffffff;
    padding-top:10px;
  `;
  const Span = styled.span`
    color: #ffffff;
    font-size: 44px;
    text-transform: uppercase;
    font-weight: 600;
    @media screen and (max-width:600px){
      font-size: 30px
    }
  `;
  const Span2 = styled.span`
    font-size: 20px;
    font-weight: 700;
  `;
  const P = styled.p`
    color: #ffffff;
    padding-top: 30px;
  `;
  return (
    <MainDiv className="" id="Home">
      <Container>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className="py-5"
        >
          <Grid xs={12} sm={12} md={12} className="my-3 py-md-5 ">
            <h1 className="fontweight py-5 mb-5 text-center">
              <Span>
                <span style={{ borderBottom: "7px solid #B82E3C", paddingBottom:'10px !important' }}>
                &nbsp; Our 
                </span>
                  <span> Message</span>
              </Span>
            </h1>
            <MainDiv2 className="mx-auto text-left">
              <P style={{textTransform:'lowercase'}}>
                {/* <strong style={{ fontSize: "30px" }}>"</strong> */}
                Four brothers was
                established with a purpose greater than just serving clients.
                The backbone of our philosophy is relationship building. We
                engage our clients in a mutually beneficial way that goes beyond
                project execution, we are happy to go out of our way to
                facilitate the unique needs of our customers with customized
                solutions. It is this approach to business that has made us a
                leading and reliable name in the global industry.
                {/* <strong className="text-right" style={{ fontSize: "30px" }}>
                  "
                </strong> */}
              </P>
              {/* <MainDiv3>
                <Span2>Asrar Saeed, </Span2>
                <span>CEO- FOUR BROTHERS</span>
              </MainDiv3> */}
            </MainDiv2>
          </Grid>
        </Grid>
      </Container>
    </MainDiv>
  );
};

export default S4_Homepage;
